import { GoogleMap, Marker, useJsApiLoader } from '@react-google-maps/api';
import React from 'react';
import { getGoogleMapCenter } from './LocationUtils';
import { appConfig } from 'config';
export const LocationMap = ({ idGeocode, ipGeocode }) => {
    const mapCenter = idGeocode && ipGeocode
        ? getGoogleMapCenter(idGeocode, ipGeocode)
        : (ipGeocode ?? idGeocode);
    const containerStyle = {
        width: '800px',
        height: '300px'
    };
    const { isLoaded } = useJsApiLoader({
        id: 'google-map-script',
        googleMapsApiKey: appConfig.googleMapsKey
    });
    return isLoaded ? (React.createElement("div", null,
        React.createElement(GoogleMap, { center: mapCenter, mapContainerClassName: "map-container", mapContainerStyle: containerStyle, zoom: 2 },
            ipGeocode && React.createElement(Marker, { position: ipGeocode, title: "Device Location" }),
            idGeocode && React.createElement(Marker, { position: idGeocode, title: "Document Location" })))) : null;
};
